'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactCollapse = require('react-collapse');
var A11yDiv = require('@narvar/nth-a11y-div');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Panel_module = require('./Panel.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var A11yDiv__default = /*#__PURE__*/_interopDefaultLegacy(A11yDiv);

const Panel = _ref => {
  let {
    fixedPanelHeight,
    header,
    children,
    sOuter = {},
    sInner = {},
    onClick,
    collapsible = false,
    open = false
  } = _ref;
  const {
    panelcontainerNoneNone: panelContainerStyle,
    panelbodyNoneNone: panelBodyStyle
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement(A11yDiv__default["default"], {
    className: Panel_module["default"].container,
    onClick: onClick,
    style: {
      ...panelContainerStyle,
      ...sOuter,
      height: fixedPanelHeight ?? (panelContainerStyle === null || panelContainerStyle === void 0 ? void 0 : panelContainerStyle.height) ?? sOuter.height ?? '100%'
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: Panel_module["default"].headerContainer
  }, header), collapsible ? /*#__PURE__*/React__default["default"].createElement(reactCollapse.Collapse, {
    isOpened: collapsible ? !!open : true
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: Panel_module["default"].scrollableContainer,
    style: {
      ...panelBodyStyle,
      ...sInner
    }
  }, children)) : /*#__PURE__*/React__default["default"].createElement("div", {
    className: Panel_module["default"].scrollableContainerScroll,
    style: {
      ...panelBodyStyle,
      ...sInner
    }
  }, children));
};
var Panel$1 = nthHookTheme.withThemeProvider(Panel, {
  themeTokens: ['panelcontainerNoneNone', 'panelbodyNoneNone']
});

exports["default"] = Panel$1;
